function updateImageSize(url, size) {
  // Replace the "_360x" part with new size
  return url.replace(/_\d+x/, `_${size}x`);
}
window.onWizzyScriptLoaded = function () {
const SPECIAL_CURRENCIES = {
        "AE": "AED","BH": "BHD","KW": "KWD","OM": "OMR","QA": "QAR","SA": "SAR", "US": "USD", "IN": "USD"
    };
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (payload) {
        // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
        let userCountry = getUserCountry().then(function(userCountry) {
          let country = SPECIAL_CURRENCIES[userCountry];
          payload.currency = country;
          window.cahce_q = payload.q;
          let query = payload.q.toLowerCase();
          const amountMatch = query.match(/\d+/);
          let amount;
          if (amountMatch) {
              amount = parseInt(amountMatch[0], 10);
          }
          if(window?.Currency && amount);
          {
            let converted_price = window.Currency.convert(amount, country, "AED");
            
            if(converted_price)
            {
              let newAmount = converted_price;
              newAmount = Math.trunc(newAmount);
              let updatedQuery = query.replace(/\d+[,\d]*/, newAmount);
              payload.q = updatedQuery;
            }
          }
      });
        return payload;
      }
    );
// Replacing default template
replaceTemplate("wizzy-search-results-product");
// replaceTemplate("wizzy-search-results");
// replaceTemplate("wizzy-search-empty-results");
replaceTemplate("wizzy-search-wrapper");
replaceTemplate("wizzy-autocomplete-topproducts");
// replaceTemplate("wizzy-autocomplete-suggestions");
replaceTemplate("wizzy-popup-modal");
// replaceTemplate("wizzy-autocomplete-wrapper");
document.addEventListener("input", function (event) {
    if (event.target.matches(".lm-serach--input.wizzy-search-input")) {
        const input = event.target;
        
        if (input.value.trim() === "") {
            console.log("wiz empty input");
            setTimeout(() => {
              input.click();
            }, 300)
            
        }
    }
});
document.addEventListener("keydown", function (event) {
    if (event.target.matches(".lm-serach--input.wizzy-search-input")) {
        const input = event.target;
        
        if (input.value.trim() === "") {
            console.log("wiz empty input");
            setTimeout(() => {
              input.click();
            }, 300)
            
        }
    }
});

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
  function (payload) {
    window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
    window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      {
          "dom": "wizzy-search-input",
          "type": "text"
      }
    ]
  //   window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

    window.wizzyConfig.common.isLazyInit = true;
    window.wizzyConfig.store.currency = {
      "code": "USD",
      "symbol": "$"
    }

    payload.search.configs.pagination.appendInExistingList=true;

    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
  function (payload) {
    window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
    window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
      {
          "dom": "wizzy-search-input",
          "type": "text"
      }
    ]
  //   window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main")

    window.wizzyConfig.common.isLazyInit = true;
    window.wizzyConfig.store.currency = {
      "code": "USD",
      "symbol": "$"
    }

    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
  function (payload) {
    // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED");
    
    payload.forEach(product => {
      if (product.url) {
        product.url = product.url.split('?')[0];
      }
      product.handle = "";
      product.fourHrsDeliveryAvailable = false;
      product.expressDelivery = false;
      if(product.attributes){
        product.attributes.forEach(attribute => {
            if(attribute.id === "product_handle"){
                if(attribute.values[0].value[0]){
                    product.handle = attribute.values[0].value[0];
                }
            }
            if(attribute.id === "product_value_tags_4hrs_delivery_new"){
                if(attribute.values[0].value[0]){
                  if(window.detectedCountryName == "AE"){
                    product.fourHrsDeliveryAvailable = true;
                  }
                }
            }
        })
      }

      if(product.attributes){
        product.attributes.forEach(attribute => {
            if(attribute.id === "product_inventory_sources"){
              if (attribute.values && attribute.values.length > 0) {
                const allInStock = attribute.values.every(v => v.inStock === true);
                // console.log(allInStock, product.fourHrsDeliveryAvailable, "wizzy there")

                const excludeCollections = window.exclude_express_collections;
                const found = product.categories.find((element) => excludeCollections.includes(element.id));
                // console.log(found == undefined, "wizz found");

                if (allInStock && (!product.fourHrsDeliveryAvailable) && window.detectedCountryName == "AE" && found == undefined) {
                  product.expressDelivery = true;
                }
              }
            }
        })
      }
      
      // console.log(product.fourHrsDeliveryAvailable, window.detectedCountryName, "Wizzy 4Hrs Delivery present");
      
      if(product.mainImage) {
        product.mainImage = updateImageSize(product.mainImage, 1296)
      }

      if (product.swatches && Array.isArray(product.swatches)) {
        product.swatches.forEach(swatch => {
            if (swatch.values && Array.isArray(swatch.values)) {
                swatch.values.forEach(color => {
                    if (color.value) {
                        let formattedColor = color.value
                          .toLowerCase()
                          .replace(/ /g, '-');       
                        // console.log(formattedColor);
                        let newSwatchUrl = `https://cdn.shopify.com/s/files/1/0889/4850/6922/files/${formattedColor}.png`;
                        // console.log(newSwatchUrl);
                        color.swatchValue = newSwatchUrl;
                    }
                });
            }
        });
      }

    })

    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  function (payload) {
  let currency = document.querySelectorAll('.isocode_currency')[0]?.innerText ??sessionStorage.getItem('currency') ?? 'USD';
  payload.currency = currency;
  sessionStorage.setItem('currency', currency);
    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
  function (payload) {
  let currency = document.querySelectorAll('.isocode_currency')[0]?.innerText ??sessionStorage.getItem('currency') ?? 'USD';
  payload.currency = currency;
  sessionStorage.setItem('currency', currency);

    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
  function (payload) {
  let currency = document.querySelectorAll('.isocode_currency')[0]?.innerText ??sessionStorage.getItem('currency') ?? 'USD';
  payload.currency = currency;
  sessionStorage.setItem('currency', currency);
    return payload;
  }
  );

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
  function (payload) {
    // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
    // payload.minQueryLength = 1;
    return payload;
  }
);

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
    // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
    return data;
  })

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
      return payload;
    }
  );

 window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
  function (payload) {
    // console.log(payload.facets,"BEFORE_SEARCH_EXECUTED")
    localStorage.removeItem('collectionsData');
    const closeButton = document.querySelector('.lm-modal--close');
    if (closeButton) {
      closeButton.click();  // Click the element if it exists
    } else {
      // console.log('Element not found');
    }

    const wizzyElement = document.querySelector('.wizzy-autocomplete-wrapper');
    if (wizzyElement) {
      wizzyElement.style.cssText += 'display: none !important;';
    }

    if(payload.facets){
      if(window.detectedCountryName == "AE"){
        const filteredFacets = payload.facets.filter(facet => facet.key !== "product_value_tags_4hrs_delivery");
        payload.facets = filteredFacets;
      }
    }

    // Check if the body element has the 'transparent-header' class
    if (document.body.classList.contains('transparent-header')) {
        document.body.classList.remove('transparent-header');
    }


    const body = document.body;
    if (body.classList.contains("body-overflow-hidden")) {
        body.classList.remove("body-overflow-hidden");
    }

    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  function (payload) {
    // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");      
    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
  function (payload) {
    // console.log(payload.filters,"PRODUCTS_CACHED_RESULTS_RENDERED");
    
    if (window.hwCurrencyConverterLoad) {
      window.hwCurrencyConverterLoad();
    }

    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
  function (data) {
    //console.log(data," <= VIEW_RENDERED");

    if (window.hwCurrencyConverterLoad) {
      window.hwCurrencyConverterLoad();
    }

    if(data.data.response){
      if(data.data.response.payload.total == 1 && window.document.documentElement.clientWidth > 768){
        const selectedFilter = document.querySelector('.wizzy-selected-filters');
        if (selectedFilter) {
          selectedFilter.style.marginTop = '50px';
        }
        const buttonElement = document.querySelector('.wizzy-search-filters-drawer-button');
        if (buttonElement) {
          buttonElement.style.position = 'absolute';
          buttonElement.style.right = '0';
        }
      }

      if(data.data.response.payload.total == 1 && window.document.documentElement.clientWidth < 768) {
        const mobileFilterButton = document.querySelector('.wizzy-mobile-filter-button');
        if (mobileFilterButton) {
          mobileFilterButton.style.width = '100%';
        }
      }

      if(data.data.response.payload.filters && window.document.documentElement.clientWidth > 768){
        if(data.data.response.payload.filters.sort[0].field === "discountPercentage" || data.data.response.payload.filters.sort[0].field === "sellingPrice"){
          // console.log("Hii there")
          if(data.data.response.payload.total > 1){
            const buttonElementFilter = document.querySelector('.wizzy-search-filters-drawer-button');
            if (buttonElementFilter) {
              buttonElementFilter.style.position = 'absolute';
              buttonElementFilter.style.right = '307px';
            }
          }
        }
      }

    }

    const modalElement = document.querySelector('.product-media-modal');
    if (modalElement) {
      modalElement.style.display = 'none';
    }

    const facetList = document.querySelector('.wizzy-selected-facet-list');
    const applyButton = document.querySelector('.wizzy-apply-all-button');

    if (facetList && applyButton) {
      if (facetList.querySelector('li')) {
        applyButton.classList.add('active');
      } else {
        applyButton.classList.remove('active');
      }
    }

    // Get all elements with the class 'noUi-tooltip'
    var tooltips = document.querySelectorAll('.noUi-tooltip');
    tooltips.forEach(function(tooltip) {
      var newElement = document.createElement('div');
      newElement.classList.add('price__container', 'noUi-tooltip');

      newElement.innerHTML = `
        <div class="price__regular">
          <span class="price-item price-item--regular">
            <span class="money">${tooltip.innerHTML}</span>
          </span>
        </div>
      `;

      tooltip.replaceWith(newElement);
    });

    // Get all elements with the class 'noUi-value'
    var values = document.querySelectorAll('.noUi-value');
    values.forEach(function(value) {
      var leftPosition = value.style.left;
      var newElement = document.createElement('div');
      newElement.classList.add('price__container', 'noUi-value', 'noUi-value-horizontal', 'noUi-value-large');
      newElement.style.left = leftPosition;
      newElement.innerHTML = `
        <div class="price__regular">
          <span class="price-item price-item--regular">
            <span class="money">${value.innerHTML}</span>
          </span>
        </div>
      `;

      value.replaceWith(newElement);
    });

   // Get all elements with the class 'wizzy-selected-facet-list-item-label'
    var facetItems = document.querySelectorAll('[data-key="_sellingPrice"] .wizzy-selected-facet-list-item-label');
    facetItems.forEach(function(facetItem) {
      var priceRange = facetItem.querySelector('.facet-item-label-value').innerText.trim();
      var prices = priceRange.split(' - ');
      // console.log(prices,"wizzy prices")
      var newElement = document.createElement('div');
      newElement.classList.add('price__container', 'wizzy-selected-facet-list-item-label');

      newElement.innerHTML = `
        <div class="price__regular">
          <span class="price-item price-item--regular">
            <span class="money">${prices[0]}</span> - <span class="money">${prices[1]}</span>
          </span>
        </div>
      `;

      if(prices[1] == undefined){
        var lowestPrice = document.querySelector(".wizzy-facet-range-slider .noUi-handle-lower .money");
        if(lowestPrice){
          lowestPrice = lowestPrice.innerHTML;
          lowestPrice = lowestPrice.replace(/\.00$/, "");
        }
        //console.log(lowestPrice,"lowestPrice");
        newElement.innerHTML = `
        <div class="price__regular">
          <span class="price-item price-item--regular"><span class="money">${lowestPrice}</span> - <span class="money">${prices[0]}</span>
          </span>
        </div>
      `;
      }

      facetItem.replaceWith(newElement);
    });



    if (window.hwCurrencyConverterLoad) {
      setTimeout(function(){
        window.hwCurrencyConverterLoad();
      },10)
    }

    if(data.data.response.payload){
      if(data.data.response.payload.total == 0){
        //console.log(data.data.response.payload.total)
        const body = document.querySelector("body");
        if (body && body.classList.contains("wizzy-filters-overlay")) {
          body.classList.remove("wizzy-filters-overlay");
          //console.log("removed overlay")
        }
      }
    }

    //////////////////////////

    const body = document.body;
    if (body.classList.contains("body-overflow-hidden")) {
        body.classList.remove("body-overflow-hidden");
    }
    
    return data;
  }
);

 window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
  function (payload) {
    // console.log(payload,"BEFORE_RENDER_RESULTS");

    if(payload.response.payload.facets){
      payload.response.payload.facets.forEach(facet => {
        if(facet.key === "product_size"){
          const sizeData = facet.data;
          sizeData.sort((a, b) => Number(a.label) - Number(b.label));
          // console.log(sizeData);
          facet.data = sizeData;
        }
      })
    }
  
    return payload;
  }
);

window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
  function (payload) {
    return payload;
  }
);
};

// Declaration of template replace function
const replaceTemplate = (div) => {
let newDiv = document.getElementById(div + "-new").text;
let oldDiv = document.getElementById(div);
oldDiv.text = newDiv;
};


/////////////////////////////////////////

const modalOpener = document.querySelector('.lm-search-modal-opner');

if (modalOpener) {
modalOpener.addEventListener('click', () => {
  const searchInput = document.querySelector('.wizzy-search-input');
  if (searchInput) {
    searchInput.click();
    searchInput.focus();

    setTimeout(() => {
      if(window.wizzyBindSearchInputs !== undefined){
        window.wizzyBindSearchInputs();
      }
    }, 200);
  }
});
}

const modalOpenerMobile = document.querySelector('#lm-search--toggleBtn');

if (modalOpenerMobile) {
modalOpenerMobile.addEventListener('click', () => {
  const searchInputMobile = document.querySelector('.wizzy-search-input');
  if (searchInputMobile) {
    setTimeout(function(){
      searchInputMobile.click();
      searchInputMobile.focus();
    }, 300);

    setTimeout(() => {
      if(window.wizzyBindSearchInputs !== undefined){
        window.wizzyBindSearchInputs();
      }
    }, 400);

  }
});
}

/////////////////////////////////////////////////////////


// Attach event listener for the close button if it exists
const closeButton = document.querySelector('.lm-sizechart--drawerClose');
if (closeButton) {
  closeButton.addEventListener('click', function() {
      const modalBackdrop = document.querySelector('.size-guide-modal-backdrop');
      const sizeChartDrawer = document.querySelector('.lm-sizechart--drawer');
      
      if (modalBackdrop && modalBackdrop.classList.contains('show')) {
          modalBackdrop.classList.remove('show');
      }
      if (sizeChartDrawer && sizeChartDrawer.classList.contains('open')) {
          sizeChartDrawer.classList.remove('open');
      }
  });
}

///////////////////////////  MUTATION OBSERVER ONE  //////////////////////

// Select the target element
const wizzyAutocompleteTargetNode = document.querySelector('.wizzy-body-end-wrapper');

function updateWizzyAutocompleteBodyClass() {
const autocompleteElement = wizzyAutocompleteTargetNode.querySelector('.wizzy-autocomplete-wrapper');
if (
  autocompleteElement &&
  window.getComputedStyle(autocompleteElement).display === 'flex'
) {
  document.body.classList.add('wizzy-autocomplete-open');
} else {
  document.body.classList.remove('wizzy-autocomplete-open');
}
}

const wizzyAutocompleteObserverConfig = {
childList: true,
subtree: true,
attributes: true,
attributeFilter: ['style']
};

const wizzyAutocompleteCallback = function (mutationsList, wizzyObserver) {
for (const mutation of mutationsList) {
  updateWizzyAutocompleteBodyClass();
  break; // One update is enough per mutation batch
}
};

const wizzyAutocompleteObserver = new MutationObserver(wizzyAutocompleteCallback);
if (wizzyAutocompleteTargetNode) {
wizzyAutocompleteObserver.observe(wizzyAutocompleteTargetNode, wizzyAutocompleteObserverConfig);
updateWizzyAutocompleteBodyClass();
}

///////////////////////////  MUTATION OBSERVER TWO  //////////////////////

function checkAndToggleApplyButton() {
  const listItems = document.querySelectorAll('.wizzy-facet-list-item');
  const applyButton = document.querySelector('.wizzy-apply-all-button');

  if (!applyButton) return;

  const anyActive = Array.from(listItems).some(item => item.classList.contains('active'));

  if (anyActive) {
      applyButton.classList.add('active');
  } else {
      applyButton.classList.remove('active');
  }
}

function observeFacetItems() {
  const listItems = document.querySelectorAll('.wizzy-facet-list-item');

  listItems.forEach(item => {
      const observer = new MutationObserver(() => {
          checkAndToggleApplyButton();
      });

      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
  });
}

// Observe when new .wizzy-facet-list-item elements are added to the DOM
const mainObserver = new MutationObserver(() => {
  observeFacetItems();  // Reattach observers if new items appear
  checkAndToggleApplyButton();
});

mainObserver.observe(document.body, { childList: true, subtree: true });

// Initial run
observeFacetItems();
checkAndToggleApplyButton();


///////////////////////////  MUTATION OBSERVER THREE  //////////////////////

// Step 1: Wait until DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  // Step 2: Select the always-present parent container
  const targetWrapper = document.querySelector('.wizzy-body-end-wrapper');

  if (!targetWrapper) {
      //console.warn('Target wrapper not found');
      return;
  }

  // Step 3: Create a MutationObserver
  const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
              // Check if .wizzy-autocomplete-wrapper was added
              mutation.addedNodes.forEach(node => {
                  if (node.nodeType === 1 && node.classList.contains('wizzy-autocomplete-wrapper')) {
                      const display = getComputedStyle(node).display;
                      if (display !== 'none') {
                          // console.log('Autocomplete shown (node added and visible)');
                          if (window.hwCurrencyConverterLoad) {
                              window.hwCurrencyConverterLoad();
                          }
                      }
                  }
              });
          }

          if (mutation.type === 'attributes' && mutation.target.classList.contains('wizzy-autocomplete-wrapper')) {
              const display = getComputedStyle(mutation.target).display;
              if (display !== 'none') {
                  // console.log('Autocomplete shown (attribute changed to visible)');
              }
          }
      }
  });

  // Step 4: Set observer config
  observer.observe(targetWrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style'],
  });

  //console.log('MutationObserver is running...');
});


///////////////////////////  MUTATION OBSERVER FOUR  //////////////////////


// Select the target node (the element you want to observe for changes)
const targetNode = document.querySelector('.modal-backdrop');

// Create a MutationObserver instance
const observerNew = new MutationObserver(function(mutationsList, observer) {
  // Check if the "show" class is present
  const body = document.body;
  if (targetNode && targetNode.classList.contains('show')) {
      // Add custom class to the body if "show" is present
      body.classList.add('custom-class');
  } else {
      // Remove custom class from the body if "show" is not present
      body.classList.remove('custom-class');
  }
});

// Configuration for the observer: watch for changes to the class attribute
const configNew = { attributes: true, attributeFilter: ['class'] };

// Start observing the target node
if (targetNode) {
  observerNew.observe(targetNode, configNew);
}
document.addEventListener('click', function(e) {
  const isWizzyNavigation = e.target.closest('.wizzy-result-product') || 
                            e.target.closest('.wizzy-autocomplete-wrapper') || 
                            e.target.closest('.wizzy__quickview__viewfull');
  if (isWizzyNavigation) {
    localStorage.removeItem('collectionsData');
  }
});